import axios
  from 'axios'

axios.defaults.baseURL =
    "https://liberal-sys.com/api/";
    // "https://staging.liberal-sys.com/api/";
    // "http://localhost:8600/api/";

axios.interceptors.request.use(
  function (config) {
    if (window.current_api_version) {
      config.headers['X-Api-Version'] = window.current_api_version;
    }
    if (typeof api.beforeRequest == 'function')
        api.beforeRequest(config);
    return config;
  },
  function (error) {
    if (typeof api.onRequestError == 'function')
        api.onRequestError(error);
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  function (res) {
    if (typeof api.onResponsed == 'function')
      api.onResponsed(res);
    return res;
  }, function (err) {
    if (typeof api.onResponseError == 'function')
      api.onResponseError(err);
    return Promise.reject(err);
  }
);
var api = {
  // Events
  beforeRequest: null,
  onRequestError: null,

  onResponsed: null,
  onResponseError: null,

  onTokenSetted: null,
  onTokenSetFailed: null,
  onTokenRemoved: null,
  //--------------------------
  setToken: function() {
    let token = localStorage.getItem('access_token');
    if (token) {
      axios
      .defaults.headers
      .common.authorization = "Bearer " + token;
      if (typeof this.onTokenSetted == 'function')
        this.onTokenSetted();
    } else {
      if (typeof this.onTokenSetFailed == 'function')
        this.onTokenSetFailed();
    }
  },
  removeToken: function() {
    localStorage.removeItem('access_token');
    delete axios.defaults.headers.common.authorization
  },
  login: function(login_name, password) {
    return axios.post('login', {
      login_name: login_name,
      password: password,
    })
    .then((res) => {
      let token = res.data.data.access_token;
      localStorage.setItem('access_token', token);
      this.setToken();
      return res
    })
  },
  logout: function(token) {
    return axios.post('logout', {}, {
      headers: {
        'Authorization': 'Bearer ' + token,
      },
    })
  },
  //--------------------------
  getOrders: function (page, service, word) {
    let params = {
      page: page || 1
    };
    if (service) {params.service_id = service;}
    if (word) {params.word = word;}
    return axios.get('orders', {
      params: params
    });
  },
  getOrderDetails: function(order_id) {
    return axios.get('orders/' + order_id)
  },
  getOrderSteps: function(order_id) {
    return axios.post('orders/' + order_id)
  },
  agreeOrder: function(order_id, is_agree) {
    let data = new FormData();
    data.append('is_agreed', is_agree);
    return axios.post('orders/' + order_id + '/agree', data)
  },
  postOrderBeforeWorkPictures: function(order_id, images){
    let data = new FormData();
    data.append('step', 1);
    data.append('images[0]', images[0] || '');
    data.append('images[1]', images[1] || '');
    data.append('images[2]', images[2] || '');
    return axios.post('orders/'+order_id, data)
  },
  postOrderAfterWorkPictures: function(order_id, images){
    let data = new FormData();
    data.append('step', 3);
    data.append('images[0]', images[0] || '');
    data.append('images[1]', images[1] || '');
    data.append('images[2]', images[2] || '');
    return axios.post('orders/'+order_id, data)
  },
  postOrderBeforeWorkSignature: function(order_id, signature){
    let data = new FormData();
    data.append('step', 2);
    data.append('images[0]', signature);
    return axios.post('orders/'+order_id, data)
  },
  postOrderAfterWorkSignature: function(order_id, signature){
    let data = new FormData();
    data.append('step', 4);
    data.append('images[0]', signature);
    return axios.post('orders/'+order_id, data)
  },
  postOrderPurchase: function(order_id, use_purchase, amount){
    let data = new FormData();
    data.append('use_purchase', use_purchase);
    data.append('amount', amount);
    return axios.post('orders/'+order_id+'/order_purchases', data)
  },
  postOrderFacePhoto: function(order_id, image){
    let data = new FormData();
    data.append('image', image || '');
    return axios.post('orders/'+order_id+'/order_face_photos', data)
  },
  getOrderSurvey: function(order_id) {
    return axios.get('/orders/'+order_id+'/surveys')
  },
  getStripeMobilePay: function(order_id, my_token) {
      return axios.get('/orders/'+order_id+'/stripe_mobile_pay/' + my_token)
  },
  postStripeMobilePay: function(order_id, total) {
      let data = new FormData();
      data.append('total',total);
      return axios.post('/orders/'+order_id+'/stripe_mobile_pay',data)
  },
  postOrderSurvey: function(order_id, questions) {
    let flatquestions = questions.reduce((acc, q)=> {
      return acc.concat(
        {
          id:     q.id,
          answer: q.answer,
        },
        q.sub_questions.yes.map((yesq)=>{
          return {
            id:     yesq.id,
            answer: yesq.answer,
          }
        }),
        q.sub_questions.no.map((noq)=>{
          return {
            id:     noq.id,
            answer: noq.answer,
          }
        })
      )
    }, []);
    return axios.post(
      'orders/'+order_id+'/surveys',
      {
        questions: JSON.stringify(flatquestions)
      }
    )
  },
  postOrderBill: function(order_id, bill) {
    return axios.post('/orders/'+order_id+'/bill', bill)
  },
  postReceipt: function(order_id, data) {
    return axios.post('/orders/'+order_id+'/receipt', data)
  },
  postInvoiceReset: function(order_id, invoice_reset) {
    return axios.post(
      'orders/' + order_id,
      {step: 4, invoice_reset: invoice_reset}
    )
  },

  getPayPubToken: function(order_id) {
    return axios.get('/payments/' + order_id + '/token')
  },
  postChargingInfo: function(order_id, data) {
    return axios.post('/payments/' + order_id + '/charges', data)
  },

  getOrderQuoteResources: function (page, order_id) {
    let params = {
      page: page || 1
    };
    return axios.get('orders/'+order_id+'/order_quote_resources', {
      params: params
    });
  },
  postOrderQuoteResource: function(order_id, type, image){
    let data = new FormData();
    data.append('order_id', order_id);
    data.append('type', type);
    data.append('image', image);
    return axios.post('orders/'+order_id+'/order_quote_resources', data)
  },
  deleteOrderQuoteResource: function (order_id, resource_id) {
    return axios.delete('orders/'+order_id+'/order_quote_resources/'+resource_id);
  },

  getOrderQuote: function(order_id) {
    return axios.get('orders/' + order_id + '/order_quotes')
  },
  postOrderQuote: function(order_id, data) {
    return axios.post('orders/'+order_id+'/order_quotes', data)
  },

  postStripePaymentIntent: function(id, params) {
    return axios.post('payments/' + id + '/stripe_payment_intent', params);
  }
};
export default api;
